import React from 'react';
import { useNavigate } from 'react-router-dom';
import './StudyDetails.css';

export const PrivacyNotice: React.FC = () => {
  const navigate = useNavigate();

  const handleBackToWelcome = () => {
    navigate('/welcome');
  };

  return (
    <div className="study-details-container">
      <div className="study-details-screen">
        <div className="study-details-header">
          <h1>Privacy Notice</h1>
          <p>Last Updated: July 10, 2025</p>
        </div>

        <div className="study-details-content">
          <section className="study-section">
            <h2>Privacy Notice</h2>
            <p>
              Welcome to our Survey. You are encouraged to review this Privacy Notice to ensure that you understand how any information you provide through the RSAC AI Showdown ("Survey") will be used by RSA Conference LLC ("RSAC" or "we").
            </p>
          </section>

          <section className="study-section">
            <h2>Information About You</h2>
            <p>
              This Privacy Notice explains how we use the information, including personal information, collected through the Survey. Please read this notice carefully. If you have any questions, you may contact us at the email address below. By visiting our survey site and participating in the Survey, you accept the practices described in this Privacy Notice.
            </p>
          </section>

          <section className="study-section">
            <h2>Information Collection</h2>
            <p>
              Information is collected when you log in to the Survey via your Google account and when you answer the Survey questions. Google may collect certain information automatically about your device, which may include information about your web browser, IP address, location, and similar information as described in the{' '}
              <a href="https://policies.google.com/privacy" target="_blank" rel="noopener noreferrer">Google Privacy Policy</a>. When you answer the Survey questions, certain business, personal and professional information is collected including, without limitation, any feedback you provide in response to the Survey questions.
            </p>
          </section>

          <section className="study-section">
            <h2>Information Use, Sharing, and Retention</h2>
            <p>
              The information collected during the Survey, including your answers to the survey questions will be used by RSAC for research purposes including for use in academic publications, but only in an anonymized and aggregated manner so that individual participants and their Survey answers cannot be identified. RSAC will not share or disclose any information or data collected during the Survey, including any personal information with Google or any other party. For more information about RSAC's privacy practices, please see the{' '}
              <a href="https://www.rsaconference.com/privacy" target="_blank" rel="noopener noreferrer">RSAC Privacy Notice</a>.
            </p>
            <p>
              We process your information for the limited purposes of helping us present and administer the Survey.
            </p>
            <p>
              Data collected including the individual Survey results will be retained for so long as such information serves a useful business purpose.
            </p>
          </section>

          <section className="study-section">
            <h2>Contact Us</h2>
            <p>
              If you have any questions or concerns that are not addressed in this Privacy Notice, please reach out to us at{' '}
              <a href="mailto:privacy@rsaconference.com">privacy@rsaconference.com</a>. For more information about our privacy practices or if you have questions, you may contact us at the email address above.
            </p>
          </section>
        </div>

        <div className="study-details-actions">
          <button 
            className="back-to-login-button"
            onClick={handleBackToWelcome}
          >
            Back
          </button>
        </div>
      </div>
    </div>
  );
};

export default PrivacyNotice; 